import React from 'react';
import InputTypesEnum from '../Enums/InputTypesEnum';
import StoredJsonDataService from '../Services/StoredJsonDataService';
import ColButton from './ColButton';
import ErrorMessage from './ErrorMessage';
import LoadingIcon from './LoadingIcon';
import OverWindow from './OverWindow';
import InputWithClear from './InputComponents/InputWithClear';
import { List, ListItem, ListItemText } from '@mui/material';
import FaIcon from './FaIcon';

class OpenJsonDataWindow extends React.Component
{
  static defaultProps = {
    saveType: '',
    clickOnCancel: () => { },
    windowText: 'Open Data',
  };

  constructor (props)
  {
    super(props);
    this.state = {
      existingNames: [],
      loading: true,
      Name: '',
    };
    this.clickOnSubmit = this.clickOnSubmit.bind(this);
    this.clickOnDelete = this.clickOnDelete.bind(this);
  }

  componentDidMount ()
  {
    this.getExistingNames();
  }

  async getExistingNames ()
  {
    this.setState({ loading: true });
    StoredJsonDataService.getExistingNames(this.props.saveType)
      .then((result) =>
      {
        this.setState({
          existingNames: result.names,
          loading: false,
          Name: '',
        });
      })
      .catch((error) =>
      {
        ErrorMessage.SetErrorMessage('OJDW51');
        this.setState({ loading: false });
      });
  }

  clickOnSubmit (e)
  {
    if (e) e.preventDefault();
    this.setState({ loading: true });
    StoredJsonDataService.getDataByNameAndType(this.state.Name, this.props.saveType)
      .then((result) =>
      {
        const item = JSON.parse(JSON.stringify(result));
        this.props.clickOnOpenFile(item);
      })
      .catch((error) =>
      {
        ErrorMessage.SetErrorMessage('OJDW68');
        this.setState({ loading: false });
      });
  }

  clickOnDelete ()
  {
    this.setState({ loading: true });
    StoredJsonDataService.deleteDataByNameAndType(this.state.Name, this.props.saveType)
      .then((result) =>
      {
        if (result.error)
        {
          ErrorMessage.SetErrorMessage(result.error);
        }
        this.getExistingNames();
      })
      .catch((error) =>
      {
        ErrorMessage.SetErrorMessage('OJDW84');
        this.setState({ loading: false });
      });
  }

  renderInputField (fieldName, labelText, colwidth, type, validityCheckerFunction)
  {
    if (type === undefined)
    {
      type = InputTypesEnum.Text;
    }
    return (
      <div className={colwidth}>
        <InputWithClear
          fieldName={fieldName}
          labelText={labelText}
          type={type}
          value={this.state[ fieldName ]}
          onChange={(fieldName, newValue) => this.setState({ [ fieldName ]: newValue })}
          validityChecker={validityCheckerFunction}
          disabled={true}
        />
      </div>
    );
  }

  renderFileList ()
  {
    return (
      <div className='p-1 m-1 col'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-11 text-center'>Files</div>
            <div className='col-1 text-right'>
              <FaIcon
                iconName='fa-solid fa-trash-can'
                disabled={!this.state.Name}
                onClick={this.clickOnDelete}
              />
            </div>
          </div>
        </div>
        <List
          className='fixedHeightList'
          dense={true}
          component='div'
          role='list'
        >
          {this.state.existingNames.map((e, index) =>
          {
            return (
              <ListItem
                key={`exf${index}`}
                button
                selected={this.state.Name === e}
                onClick={() => this.setState({ Name: e })}
                onDoubleClick={() =>
                {
                  this.setState({ Name: e });
                  this.clickOnSubmit();
                }}
              >
                <ListItemText primary={e} />
              </ListItem>
            );
          })}
        </List>
      </div>
    );
  }

  renderButtons ()
  {
    return (
      <div className='buttonfooter'>
        <div className='container-fluid'>
          <div className='row'>
            <ColButton
              text='Cancel'
              onClick={this.props.clickOnCancel}
            />
            <ColButton
              text='Open'
              type='submit'
              icon='fa-solid fa-folder-open'
              disabled={!this.state.Name}
            />
          </div>
        </div>
      </div>
    );
  }

  renderContent ()
  {
    return (
      <form onSubmit={this.clickOnSubmit}>
        <div className='container-fluid'>
          <div className='row'>{this.renderFileList()}</div>
          <div className='row'>{this.renderInputField('Name', 'Name', 'col', InputTypesEnum.Text)}</div>

          {this.renderButtons()}
        </div>
      </form>
    );
  }

  render ()
  {
    return (
      <OverWindow
        clickOnCancel={this.props.clickOnCancel}
        title={this.props.windowText}
        closeOnClickOutside={false}
        maxWidth={800}
        iconName='fa-solid fa-folder-open'
      >
        <div className=' p-1 m-1'>{this.state.loading ? <LoadingIcon loading={true} /> : this.renderContent()}</div>
      </OverWindow>
    );
  }
}

export default OpenJsonDataWindow;
